import React, { useState, useEffect } from "react";
import { Table, Badge, Spinner, Button } from "react-bootstrap";
import { getPaymentLogs, getPaymentLogDetails } from "../../services/adminApi";
import './AdminPaymentLogs.css';

const AdminPaymentLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("list");
  const [selectedLog, setSelectedLog] = useState(null);

  useEffect(() => { loadLogs(); }, []);

  const loadLogs = async () => {
    try {
      const response = await getPaymentLogs();
      setLogs(response.data.data || []);
    } catch (error) { console.error(error); }
    finally { setLoading(false); }
  };

  const handleView = async (id) => {
    try {
      const response = await getPaymentLogDetails(id);
      setSelectedLog(response.data.data);
      setView("form");
    } catch (error) { console.error(error); }
  };

  if (loading) return <div className="text-center p-5"><Spinner /></div>;

  return (
    <div className="container-fluid">
      {view === "list" ? (
        <>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="mb-0">Payment Logs</h3>
            <Badge bg="dark">Total : {logs.length}</Badge>
          </div>
          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>User</th><th>Email</th><th>Gateway</th><th>Order ID</th>
                <th>Payment ID</th><th>Amount</th><th>Status</th><th>Date</th><th>Action</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id}>
                  <td>{log.user_name}</td>
                  <td>{log.email}</td>
                  <td>{log.gateway_provider || "-"}</td>
                  <td>{log.order_id || "-"}</td>
                  <td>{log.payment_id || "-"}</td>
                  <td>₹{log.amount}</td>
                  <td>
                    <Badge bg={log.payment_status === "SUCCESS" || log.payment_status === "BOOKED" ? "success" : log.payment_status === "FAILED" ? "danger" : "warning"}>
                      {log.payment_status}
                    </Badge>
                  </td>
                  <td>{log.created_at ? new Date(log.created_at).toLocaleDateString("en-IN") : "-"}</td>
                  <td><Button size="sm" variant="dark" onClick={() => handleView(log.id)}>View</Button></td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      ) : (
        <div className="card shadow payment-details-card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4 className="mb-0">Payment Details</h4>
            <Button variant="secondary" onClick={() => setView("list")}>Back</Button>
          </div>
          <div className="card-body payment-log">
            <div className="row">
              <div className="col-md-4 mb-3"><label>User Name</label><input className="form-control payment-input" value={selectedLog?.user_name || ""} readOnly /></div>
              <div className="col-md-4 mb-3"><label>Email</label><input className="form-control payment-input" value={selectedLog?.email || ""} readOnly /></div>
              <div className="col-md-4 mb-3"><label>Gateway</label><input className="form-control payment-input" value={selectedLog?.gateway_provider || ""} readOnly /></div>
              <div className="col-md-4 mb-3"><label>Order ID</label><input className="form-control payment-input" value={selectedLog?.order_id || ""} readOnly /></div>
              <div className="col-md-4 mb-3"><label>Payment ID</label><input className="form-control payment-input" value={selectedLog?.payment_id || ""} readOnly /></div>
              <div className="col-md-4 mb-3"><label>Status</label><input className="form-control payment-input" value={selectedLog?.payment_status || ""} readOnly /></div>
              <div className="col-md-4 mb-3"><label>Amount</label><input className="form-control payment-input" value={`₹${selectedLog?.amount || 0}`} readOnly /></div>
              <div className="col-md-4 mb-3"><label>Date</label><input className="form-control payment-input" value={selectedLog?.created_at ? new Date(selectedLog.created_at).toLocaleDateString("en-IN") : "-"} readOnly /></div>
              <div className="col-12 mt-3">
                <label>Gateway Response</label>
                <textarea rows={3} className="form-control payment-input gateway-response" value={selectedLog?.payment_response || ""} readOnly />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminPaymentLogs;